import * as yup from 'yup';

const StateTsrModalSchema = (): yup.AnyObjectSchema => {
  const typeErrorText = 'Invalid time format. Must be hh:mm (A|P)M';

  const schema = yup
    .object({
      stateFullName: yup.string().required('State full name is required'),
      state: yup.string().required('State short name is required!'),
      monFriStart: yup
        .date()
        .nullable()
        .typeError(typeErrorText)
        .required('Weekdays start time is required!'),
      monFriEnd: yup
        .date()
        .nullable()
        .typeError(typeErrorText)
        .required('Weekdays end time is required!'),
      satStart: yup
        .date()
        .nullable()
        .typeError(typeErrorText)
        .required('Saturday start time is required!'),
      satEnd: yup
        .date()
        .nullable()
        .typeError(typeErrorText)
        .required('Saturday end time is required!'),
      sunStart: yup.date().nullable().typeError(typeErrorText),
      sunEnd: yup.date().nullable().typeError(typeErrorText),
    })
    .required();

  return schema;
};

export default StateTsrModalSchema;
